import React from "react";
import { Link,Outlet } from "react-router-dom";
export default function Communicate(){
    return(
        <div>
            <div className="flex flex-col space-y-2">                
                <Link to="bank_owners" className="hover:text-blue-500">BankOwners</Link>
                <Link to="customers" className="hover:text-blue-500">Customers</Link>
                <Link to="farmers" className="hover:text-blue-500">Farmers</Link>
                <Link to="hotel_owners" className="hover:text-blue-500">HotelOwners</Link>
                <Link to="transport_owners" className="hover:text-blue-500">TransportOwners</Link>                
            </div>
            <Outlet/>
        </div>
    )
}